import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../AuthContext"; // AuthContext에서 user 상태 가져오기
import "../styles/Header.css"; // 스타일 적용을 위한 CSS 파일
import { FaCog, FaSignOutAlt } from "react-icons/fa"; // 설정 및 로그아웃 아이콘

const Header = () => {
    const { user } = useAuth(); // user 정보 가져오기
    const [menuOpen, setMenuOpen] = useState(false); // 메뉴 상태 관리

    

    const menuItems = [];
    const userType = user?.userType || ""; // 로그인되지 않은 경우 빈 문자열

    // 컴포넌트가 마운트될 때 userType을 공백으로 설정
    //useEffect(() => {



    //}, []); // setUserType이 변경될 때마다 실행
    //alert(userType);


    
    const menuRef = useRef(null); // 메뉴 영역을 감지할 ref
    const buttonRef = useRef(null); // 햄버거 버튼을 위한 ref
    /// 메뉴 버튼 클릭 시 상태 변경 (열려있다면 닫기만 수행)
    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    // 메뉴 바깥 클릭 시 메뉴 닫기
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current && !menuRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target) // 버튼도 제외
            ) {
                setMenuOpen(false); // 메뉴 닫기
            }
        };

        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);



    if (userType === "S") {
        menuItems.push(
            { name: "봉안관리", path: "/enshrine" },
            { name: "묘지검색", path: "/tombsmap" },
            { name: "사용자 관리", path: "/account" },
            { name: "파트너 관리", path: "/partner" },
            { name: "관할 관공서", path: "/government" },            
            {
                name: <FaCog size={12} />, // '내설정'을 설정 아이콘으로 변경
                path: "/mysetup"
            },
            {
                name: <FaSignOutAlt size={12} />, // '로그아웃'을 로그아웃 아이콘으로 변경
                path: "/logout"
            }
        );
    } else if (userType === "U") {
        menuItems.push(
            { name: "봉안관리", path: "/enshrine" },
            {
                name: <FaCog size={12} />, // '내설정'을 설정 아이콘으로 변경
                path: "/mysetup"
            },
            {
                name: <FaSignOutAlt size={12} />, // '로그아웃'을 로그아웃 아이콘으로 변경
                path: "/logout"
            }
        );
    } else if (userType === "P") {
        menuItems.push(
            { name: "봉안관리", path: "/enshrine" },
            { name: "묘지검색", path: "/tombsmap" },
            { name: "사용자 관리", path: "/account" },            
            {
                name: <FaCog size={12} />, // '내설정'을 설정 아이콘으로 변경
                path: "/mysetup"
            },
            {
                name: <FaSignOutAlt size={12} />, // '로그아웃'을 로그아웃 아이콘으로 변경
                path: "/logout"
            }
        );
    } else if (userType === "G") {
        menuItems.push(
            { name: "묘지검색", path: "/tombsmap" },
            {
                name: <FaCog size={12} />, // '내설정'을 설정 아이콘으로 변경
                path: "/mysetup"
            },
            {
                name: <FaSignOutAlt size={12} />, // '로그아웃'을 로그아웃 아이콘으로 변경
                path: "/logout"
            }
        );
    } else {
        menuItems.push(
            { name: "로그인", path: "/login" }
        );
    }
        
        
    //}

    return (
        <header className="header">
            <div className="logo">
                {userType ? (
                    <NavLink to="/enshrine" className="logo-link">빛담 디지털 추모관</NavLink>
                ) : (
                        <span className="logo-text">빛담 디지털 추모관</span>
                )}
            </div>

            {/* 햄버거 메뉴 버튼 */}
            <button ref={buttonRef} className="menu-toggle" onClick={toggleMenu}>
                ☰
            </button>

            {/* 네비게이션 */}
            <nav ref={menuRef} className={menuOpen ? "nav open" : "nav"}>
                <ul>
                    {/* {userType === "" && <li><NavLink to="/login">로그인</NavLink></li>} */}
                    {menuItems.map((item) => (
                        <li key={item.path}>
                            <NavLink to={item.path} onClick={() => setMenuOpen(false)}>
                                {item.name}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
};

export default Header;
